import { render, staticRenderFns } from "./productItemsList.vue?vue&type=template&id=99051522&scoped=true&"
import script from "./productItemsList.vue?vue&type=script&lang=js&"
export * from "./productItemsList.vue?vue&type=script&lang=js&"
import style0 from "./productItemsList.vue?vue&type=style&index=0&id=99051522&prod&scoped=true&lang=css&"
import style1 from "./productItemsList.vue?vue&type=style&index=1&id=99051522&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99051522",
  null
  
)

export default component.exports